import { Component } from '@angular/core';

@Component({
  selector: 'app-ui-icons',
  templateUrl: './ui-icons.component.html',
  styleUrls: ['./ui-icons.component.css']
})
export class UiIconsComponent {
  /**
   * Header button list show
   */
  Settingicon = true;
  Menuoption = 'center'
}
